import { useEffect, useState } from 'react';

export function useSelectedItems(orders) {
	const [selectedItems, setSelectedItems] = useState([]);

	useEffect(() => setSelectedItems([]), [orders]);

	return [selectedItems, setSelectedItems];
}
